import { AutoComplete } from 'primereact/autocomplete'
import { Calendar } from 'primereact/calendar'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { useEffect, useRef, useState } from 'react'

import { formattingTime } from '../../../../Components/Common/Functions'
import { getColorDiff } from './Functions'

const dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' }
const fontStyle = { fontFamily: 'var(--font-family)', fontSize: 14 }

export const FloatInput = ({
  value: [value, setValue],
  label,
  id,
  type,
  options,
  error,
  autocompleteField = 'label',
  onSelect,
  readOnly,
  minDate,
  diffStatus,
  style = {},
  limitLength
}) => {
  const [suggestions, setSuggestions] = useState([])
  const maxLength = limitLength && limitLength > 0 ? limitLength : undefined
  const textareaRef = useRef(null)

  useEffect(() => {
    const el = textareaRef.current
    if (!el) return
    el.style.height = 'auto'
    el.style.height = el.scrollHeight + 'px'
  }, [value])

  const search = (event) => {
    if (!event.query.trim().length) setSuggestions([...options])
    else
      setSuggestions(
        options.filter(({ [autocompleteField]: label }) =>
          label.toLowerCase().startsWith(event.query.toLowerCase())
        )
      )
  }

  const renderCorrectInput = () => {
    switch (type) {
      case 'date':
        return (
          <Calendar
            disabled={readOnly}
            value={
              value && new Date(value.split('/')[2], value.split('/')[1] - 1, value.split('/')[0])
            }
            onChange={(e) => setValue(e.value?.toLocaleDateString('it', dateOptions))}
            dateFormat="dd/mm/yy"
            id={id}
            className={error ? 'p-invalid' : ''}
            inputStyle={{ ...fontStyle, color: getColorDiff(diffStatus, error) }}
            style={{ width: '100%', ...style }}
            {...(minDate && { minDate })}
          />
        )
      case 'dropdown':
        return (
          <Dropdown
            style={{ width: '100%', ...style }}
            id={id}
            className={error ? 'p-invalid' : ''}
            disabled={readOnly}
            value={value}
            onChange={(e) => !readOnly && setValue(e.value)}
            options={options}
          />
        )
      case 'time':
        return (
          <InputText
            style={{
              ...fontStyle,
              width: '100%',
              color: getColorDiff(diffStatus, error),
              ...style
            }}
            id={id}
            onChange={(e) => setValue(e.target.value)}
            onBlur={(e) => setValue(formattingTime(e.target.value))}
            value={value}
            className={error ? 'p-invalid' : ''}
            disabled={readOnly}
            maxLength={maxLength}
          />
        )
      case 'autocomplete':
        return (
          <AutoComplete
            disabled={readOnly}
            field={autocompleteField}
            className={error ? 'p-invalid' : ''}
            id={id}
            onSelect={(e) => onSelect(e.value)}
            style={{ width: '100%' }}
            value={value}
            suggestions={suggestions}
            completeMethod={search}
            onChange={(e) => setValue(e.value)}
            inputStyle={{
              ...fontStyle,
              width: '100%',
              color: getColorDiff(diffStatus, error),
              ...style
            }}
            inputProps={{ maxLength }}
          />
        )
      case 'numeric': {
        return (
          <InputText
            style={{
              ...fontStyle,
              width: '100%',
              color: getColorDiff(diffStatus, error),
              ...style
            }}
            id={id}
            onChange={(e) => setValue(e.target.value)}
            value={value}
            className={error ? 'p-invalid' : ''}
            disabled={readOnly}
            keyfilter="int"
            maxLength={maxLength}
          />
        )
      }
      case 'textarea': {
        return (
          <textarea
            ref={textareaRef}
            style={{
              ...fontStyle,
              width: '100%',
              color: getColorDiff(diffStatus, error),
              marginBottom: -5,
              ...style
            }}
            id={id}
            onChange={(e) => setValue(e.target.value)}
            value={value || ''}
            className={`p-inputtext p-component p-inputtextarea${value ? ' p-filled' : ''}${error ? ' p-invalid' : ''}`}
            disabled={readOnly}
            rows={3}
            maxLength={maxLength}
          />
        )
      }
      default:
        return (
          <InputText
            style={{
              ...fontStyle,
              width: '100%',
              color: getColorDiff(diffStatus, error),
              ...style
            }}
            id={id}
            onChange={(e) => setValue(e.target.value)}
            value={value}
            className={error ? 'p-invalid' : ''}
            disabled={readOnly}
            maxLength={maxLength}
          />
        )
    }
  }

  return (
    <div className="nfield" style={{ marginTop: 25, width: '100%' }}>
      <span className="p-float-label">
        {renderCorrectInput()}
        <label style={{ fontFamily: 'var(--font-family)', color: getColorDiff(diffStatus, error) }}>
          {label}
        </label>
      </span>
    </div>
  )
}
